let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("S52rf")]).then(() => parcelRequire('58gQo'));